import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { setAuthToken } from '../lib/api';
import UnifiedDashboard from './UnifiedDashboard';
import { ArrowRight, Sparkles } from 'lucide-react';

const DemoPage = () => {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initDemo = async () => {
      try {
        // Create a demo session
        const res = await api.post('/api/auth/demo-session');
        if (res.data.session_token) {
          setAuthToken(res.data.session_token);
        }
        setReady(true);
      } catch (err) {
        console.error('Demo init failed:', err);
        setError('Failed to load demo. Please try again.');
      }
    };
    initDemo();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50" style={{ fontFamily: "'DM Sans', sans-serif" }}>
        <div className="text-center">
          <p className="text-gray-500 mb-4">{error}</p>
          <button onClick={() => navigate('/')} className="text-blue-600 font-semibold text-sm hover:underline">
            Go to homepage
          </button>
        </div>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50" style={{ fontFamily: "'DM Sans', sans-serif" }}>
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-sm text-gray-500">Loading demo dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      {/* Sticky Demo Banner */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2.5 text-center text-sm font-medium sticky top-0 z-[60] flex items-center justify-center gap-3" data-testid="demo-banner">
        <Sparkles className="w-4 h-4 hidden sm:block" />
        <span>You're exploring a live demo with sample data</span>
        <button
          data-testid="demo-signup-btn"
          onClick={() => {
            localStorage.removeItem('session_token');
            navigate('/');
          }}
          className="bg-white text-blue-600 px-4 py-1 rounded-md font-semibold text-xs hover:bg-blue-50 transition-colors flex items-center gap-1.5"
        >
          Sign up free <ArrowRight className="w-3 h-3" />
        </button>
      </div>

      {/* Real Dashboard */}
      <UnifiedDashboard />
    </div>
  );
};

export default DemoPage;
